const tab = (triggers: NodeListOf<HTMLElement>): void => {
	let panelHeight = 0;
	let currentSelectedTrigger: HTMLElement | null = null;
	let currentOpendPanel: HTMLElement | null = null;

	const toggleAttribute = (
		trigger: HTMLElement,
		panel: HTMLElement,
		prevTrigger: HTMLElement,
		prevPanel: HTMLElement,
	): void => {
		trigger.setAttribute("aria-selected", "true");
		trigger.setAttribute("tabindex", "0");
		panel.removeAttribute("inert");

		prevTrigger.setAttribute("aria-selected", "false");
		prevTrigger.setAttribute("tabindex", "-1");
		prevPanel.setAttribute("inert", "");
	};

	triggers.forEach((element) => {
		const controls = element.getAttribute("aria-controls");
		if (!controls) return;

		const panel = document.getElementById(controls);
		if (!panel) return;

		const container = panel.parentElement;
		panelHeight = Math.max(panel.clientHeight, panelHeight);

		if (container !== null) {
			(container as HTMLElement).style.height = `${panelHeight + 2}px`;
		}

		if (element.getAttribute("aria-selected") === "true") {
			currentSelectedTrigger = element;
			currentOpendPanel = panel;
		}

		element.addEventListener("click", function () {
			if (this.getAttribute("aria-selected") === "true") return;

			if (currentSelectedTrigger && currentOpendPanel) {
				toggleAttribute(this, panel, currentSelectedTrigger, currentOpendPanel);
			}

			currentSelectedTrigger = this;
			currentOpendPanel = panel;
		});

		element.addEventListener("keydown", function (event: KeyboardEvent) {
			const previousElement = this.previousElementSibling as HTMLElement | null;
			const nextElement = this.nextElementSibling as HTMLElement | null;
			let focusElement: HTMLElement | null = null;
			let openPanel: HTMLElement | null = null;

			switch (event.key) {
				case "ArrowLeft":
					focusElement = previousElement ?? triggers[triggers.length - 1];
					break;
				case "ArrowRight":
					focusElement = nextElement ?? triggers[0];
					break;
				default:
					return;
			}

			focusElement.focus();
			const newControls = focusElement.getAttribute("aria-controls");
			if (!newControls) return;

			openPanel = document.getElementById(newControls);
			if (!openPanel || !currentSelectedTrigger || !currentOpendPanel) return;

			toggleAttribute(
				focusElement,
				openPanel,
				currentSelectedTrigger,
				currentOpendPanel,
			);
			currentSelectedTrigger = focusElement;
			currentOpendPanel = openPanel;
		});
	});
};
export default tab;
